"use client"
import { ActionIcon, Indicator, Tooltip, Group } from "@mantine/core"
import { useSelector } from "@legendapp/state/react"
import { IconBulb } from "@tabler/icons-react"
import classes from "./NavbarButtonFeatureBase.module.css"
import { featurebaseStore$ } from "@/stores/featurebase.store"
import { ensureFeaturebaseCommandQueue, type FeaturebaseWindow } from "@/lib/featurebase"

interface NavbarButtonFeatureBaseProps {
  label: string
}

export function NavbarButtonFeatureBase({ label }: NavbarButtonFeatureBaseProps) {
  const isIdentified = useSelector(() => featurebaseStore$.isIdentified.get())
  const unreadCount = useSelector(() => featurebaseStore$.unreadCount.get())

  function handleClick() {
    const featurebase = ensureFeaturebaseCommandQueue(window as FeaturebaseWindow)

    featurebase("set_all_changelogs_as_viewed")
    featurebaseStore$.unreadCount.set(0)
  }

  return (
    <Group justify="center" align="center">
      <Tooltip position="right" label={label}>
        <Indicator disabled={!isIdentified || unreadCount === 0} inline size={15} label={unreadCount} color="red" offset={3}>
          <ActionIcon
            aria-label={label}
            className={classes.actionIcon}
            data-featurebase-feedback-portal=""
            data-testid="btn-open-featurebase-widget"
            variant={"transparent"}
            color={"gray.3"}
            size="lg"
            radius="md"
            disabled={!isIdentified}
            onClick={handleClick}
          >
            <IconBulb className={classes.icon} />
          </ActionIcon>
        </Indicator>
      </Tooltip>
    </Group>
  )
}
